module.exports = __webpack_public_path__ + "static/media/lego4.1c4ed875.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lego4.png
// module id = 291
// module chunks = 0